import { SVGProps, Ref, forwardRef, useId } from 'react';

export const MaxSquareBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <mask
                    id={`${_uniqueId}mask0_15053_908`}
                    style={{
                        maskType: 'alpha',
                    }}
                    maskUnits="userSpaceOnUse"
                    x={1}
                    y={1}
                    width={14}
                    height={14}
                    suppressHydrationWarning
                >
                    <rect
                        x={1}
                        y={1}
                        width={14}
                        height={14}
                        rx={2.917}
                        fill={`url(#${_uniqueId}paint0_linear_15053_908)`}
                        suppressHydrationWarning
                    />
                </mask>
                <g mask={`url(#${_uniqueId}mask0_15053_908)`} suppressHydrationWarning>
                    <rect x={1} y={1} width={14} height={14} fill="white" />
                    <g filter={`url(#${_uniqueId}filter0_f_15053_908)`} suppressHydrationWarning>
                        <circle cx={6.25} cy={6.833} r={9.333} fill="#2A40F1" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter1_f_15053_908)`} suppressHydrationWarning>
                        <circle cx={16.75} cy={-0.75} r={9.333} fill="#8950E1" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter2_f_15053_908)`} suppressHydrationWarning>
                        <circle cx={0.417} cy={17.333} r={9.333} fill="#4AC1FC" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter3_f_15053_908)`} suppressHydrationWarning>
                        <circle cx={17.333} cy={15} r={9.333} fill="#A261DF" />
                    </g>
                </g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.1 12.64c-.92 0-1.348-.134-2.092-.671-.47.604-1.96 1.076-2.025.268 0-.606-.134-1.119-.287-1.678-.181-.69-.387-1.458-.387-2.57 0-2.657 2.182-4.656 4.767-4.656 2.588 0 4.615 2.098 4.615 4.68a4.617 4.617 0 0 1-4.59 4.627m.039-7.01c-1.26-.065-2.24.806-2.458 2.171-.179 1.13.14 2.507.41 2.578.13.032.457-.232.661-.436.337.233.73.372 1.138.405a2.4 2.4 0 0 0 2.507-2.231A2.394 2.394 0 0 0 8.14 5.632z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_f_15053_908`}
                    x={-10.258}
                    y={-9.675}
                    width={33.017}
                    height={33.017}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={3.587} result="effect1_foregroundBlur_15053_908" />
                </filter>
                <filter
                    id={`${_uniqueId}filter1_f_15053_908`}
                    x={0.242}
                    y={-17.258}
                    width={33.017}
                    height={33.017}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={3.587} result="effect1_foregroundBlur_15053_908" />
                </filter>
                <filter
                    id={`${_uniqueId}filter2_f_15053_908`}
                    x={-16.091}
                    y={0.825}
                    width={33.017}
                    height={33.017}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={3.587} result="effect1_foregroundBlur_15053_908" />
                </filter>
                <filter
                    id={`${_uniqueId}filter3_f_15053_908`}
                    x={0.825}
                    y={-1.508}
                    width={33.017}
                    height={33.017}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={3.587} result="effect1_foregroundBlur_15053_908" />
                </filter>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_15053_908`}
                    x1={4.5}
                    y1={3.917}
                    x2={15}
                    y2={8}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#2242F7" />
                    <stop offset={1} stopColor="#A35EDE" />
                </linearGradient>
            </defs>
        </svg>
    );
});
MaxSquareBrandSize16Glyph.displayName = 'MaxSquareBrandSize16Glyph';
